import Text from '@eversports/react-components/primitives/Text'
import React from 'react'

import { makeStyles } from '@mui/styles'
import { Theme } from '@eversports/react-components/design-tokens/theme'
import { Localized } from '../../localization/react'

interface Props {
  onAddVoucherClick: () => void
}

const useStyles = makeStyles(({ palette }: Theme) => ({
  container: {
    border: `1px solid ${palette.primary.main}`,
    borderRadius: '4px',
    padding: '4px 16px',
    width: 'fit-content',
  },
}))

const VoucherSelectionReady = ({ onAddVoucherClick: handleAddVoucherClick }: Props) => {
  const classes = useStyles()
  return (
    <Text
      color="primary.main"
      size="small"
      className={classes.container}
      onClick={handleAddVoucherClick}
      showPointer
      useHover
    >
      <Localized id="add-voucher" />
    </Text>
  )
}

export default VoucherSelectionReady
